import React from 'react';

const LoyaltyPointsIcon: React.FC = () => (
    <svg viewBox="0 0 131.2 48.1" width="131.2" height="48.1">
        <g fill="none" stroke="currentColor" strokeWidth="2.126" strokeMiterlimit="10">
            <polygon points="65.4,38.3 79.1,45.7 76.6,30.4 87.8,19.6 72.5,17.3 65.7,3.3 58.7,17.2 43.4,19.3 54.4,30.2 51.7,45.5"/>
            <polygon points="20.9,40.6 30.3,45.7 28.6,35 36.4,27.6 25.7,26 21,16.3 16.2,25.9 5.6,27.4 13.2,34.9 11.3,45.5"/>
            <polygon points="110.1,40.6 119.6,45.7 117.9,35 125.6,27.6 115,26 110.3,16.3 105.5,25.9 94.8,27.4 102.5,34.9 100.6,45.5"/>
        </g>
    </svg>

);
export { LoyaltyPointsIcon };
